import { render, staticRenderFns } from "./nickAndAvatar.vue?vue&type=template&id=6c98f8a9&scoped=true&"
import script from "./nickAndAvatar.vue?vue&type=script&lang=js&"
export * from "./nickAndAvatar.vue?vue&type=script&lang=js&"
import style0 from "./nickAndAvatar.vue?vue&type=style&index=0&id=6c98f8a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c98f8a9",
  null
  
)

export default component.exports